import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import SplashScreen from "@/components/SplashScreen";
import InstallPrompt from "@/components/InstallPrompt";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Feed from "@/pages/Feed";
import Onboarding from "@/pages/Onboarding";
import UploadPage from "@/pages/Upload";
import Dashboard from "@/pages/Dashboard";
import Wallet from "@/pages/Wallet";
import SearchPage from "@/pages/Search";
import Shop from "@/pages/Shop";
import Admin from "@/pages/Admin";
import Watch from "@/pages/Watch";

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/feed" replace />} />
            <Route path="/feed" element={<Feed />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/upload" element={<UploadPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/shop/:slug" element={<Shop />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/watch/:productId" element={<Watch />} />
            <Route path="*" element={<Navigate to="/feed" replace />} />
        </Routes>
    );
}

function App() {
    const [splashDone, setSplashDone] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.location.hash?.includes("session_id=") || window.location.pathname.startsWith("/auth/callback");
    });

    return (
        <div className="App">
            <ErrorBoundary>
                {!splashDone && <SplashScreen onDone={() => setSplashDone(true)} />}
                <AuthProvider>
                    <BrowserRouter>
                        <AppRouter />
                        <InstallPrompt />
                        <Toaster theme="dark" position="top-center" richColors />
                    </BrowserRouter>
                </AuthProvider>
            </ErrorBoundary>
        </div>
    );
}

export default App;
